import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9 } from "styled-components";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dateFormat from "dateformat";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import Cartographic from "terriajs-cesium/Source/Core/Cartographic";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import createGuid from "terriajs-cesium/Source/Core/createGuid";
import SplitDirection from "terriajs-cesium/Source/Scene/SplitDirection";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import prettifyCoordinates from "../../../Map/Vector/prettifyCoordinates";
import DiffableMixin from "../../../ModelMixins/DiffableMixin";
import MappableMixin, { ImageryParts } from "../../../ModelMixins/MappableMixin";
import SplitItemReference from "../../../Models/Catalog/CatalogReferences/SplitItemReference";
import CommonStrata from "../../../Models/Definition/CommonStrata";
import hasTraits from "../../../Models/Definition/hasTraits";
import updateModelFromJson from "../../../Models/Definition/updateModelFromJson";
import { getMarkerLocation, removeMarker } from "../../../Models/LocationMarkerUtils";
import Box, { BoxSpan } from "../../../Styled/Box";
import Button, { RawButton } from "../../../Styled/Button";
import { GLYPHS, StyledIcon } from "../../../Styled/Icon";
import Select from "../../../Styled/Select";
import Spacing from "../../../Styled/Spacing";
import Text, { TextSpan } from "../../../Styled/Text";
import ImageryProviderTraits from "../../../Traits/TraitsClasses/ImageryProviderTraits";
import { useViewState } from "../../Context";
import { parseCustomMarkdownToReactWithOptions } from "../../Custom/parseCustomMarkdownToReact";
import Loader from "../../Loader";
import WorkflowPanel from "../../Workflow/WorkflowPanel";
import DatePicker from "./DatePicker";
import LocationPicker from "./LocationPicker";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DiffTool = observer(props => {
  const [leftItem, setLeftItem] = useState();
  const [rightItem, setRightItem] = useState();
  const [userSelectedSourceItem, setUserSelectedSourceItem] = useState();
  const viewState = useViewState();
  const changeSourceItem = sourceItem => {
    setUserSelectedSourceItem(sourceItem);
  };
  const sourceItem = useMemo(() => userSelectedSourceItem || props.sourceItem, [props.sourceItem, userSelectedSourceItem]);
  useEffect(() => {
    const terria = viewState.terria;
    const originalSettings = {
      showSplitter: terria.showSplitter,
      isMapFullScreen: viewState.isMapFullScreen
    };
    runInAction(() => {
      terria.showSplitter = true;
      sourceItem.setTrait(CommonStrata.user, "show", false);
      terria.elements.set("timeline", {
        visible: false
      });
    });
    const itemsPromise = Promise.all([createSplitItem(sourceItem, SplitDirection.LEFT), createSplitItem(sourceItem, SplitDirection.RIGHT)]);
    itemsPromise.then(_ref => {
      let [lItem, rItem] = _ref;
      setLeftItem(lItem);
      setRightItem(rItem);
    }).catch();
    return () => {
      runInAction(() => {
        terria.showSplitter = originalSettings.showSplitter;
        viewState.setIsMapFullScreen(originalSettings.isMapFullScreen);
        sourceItem.setTrait(CommonStrata.user, "show", true);
        terria.elements.set("timeline", {
          visible: true
        });
      });
      itemsPromise.then(_ref2 => {
        let [lItem, rItem] = _ref2;
        if (lItem) removeSplitItem(lItem);
        if (rItem) removeSplitItem(rItem);
      });
    };
  }, [sourceItem, viewState]);
  if (leftItem && rightItem) {
    return /*#__PURE__*/_jsx(Main, _objectSpread(_objectSpread({}, props), {}, {
      terria: props.viewState.terria,
      sourceItem: sourceItem,
      changeSourceItem: changeSourceItem,
      leftItem: leftItem,
      rightItem: rightItem
    }));
  }
  return null;
});
DiffTool.displayName = "DiffTool";
const Main = observer(props => {
  var _diffItem$styleSelect3;
  const {
    terria,
    viewState,
    sourceItem,
    leftItem,
    rightItem
  } = props;
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const [location, setLocation] = useState();
  const [, setLocationPickError] = useState(false);
  const [isPickingNewLocation, setIsPickingNewLocation] = useState(false);
  const leftDatePickerHandle = useRef(null);
  const rightDatePickerHandle = useRef(null);
  const diffItem = useMemo(() => {
    return leftItem;
  }, [leftItem]);
  const currentLeftDate = useMemo(() => {
    return leftItem.currentDiscreteJulianDate;
  }, [leftItem.currentDiscreteJulianDate]);
  const currentRightDate = useMemo(() => {
    return rightItem.currentDiscreteJulianDate;
  }, [rightItem.currentDiscreteJulianDate]);
  const diffItemName = useMemo(() => {
    const name = sourceItem.name || "";
    const format = "yyyy/mm/dd";
    if (!currentLeftDate || !currentRightDate) {
      return name;
    } else {
      const d1 = dateFormat(JulianDate.toDate(currentLeftDate), format);
      const d2 = dateFormat(JulianDate.toDate(currentRightDate), format);
      return "".concat(name, " - difference for dates ").concat(d1, ", ").concat(d2);
    }
  }, [currentLeftDate, currentRightDate, sourceItem.name]);
  const diffableItemsInWorkbench = useMemo(() => {
    return terria.workbench.items.filter(item => DiffableMixin.isMixedInto(item) && item.canDiffImages);
  }, [terria.workbench.items]);
  const previewStyle = useMemo(() => {
    var _diffItem$styleSelect;
    return (_diffItem$styleSelect = diffItem.styleSelectableDimensions) === null || _diffItem$styleSelect === void 0 || (_diffItem$styleSelect = _diffItem$styleSelect[0]) === null || _diffItem$styleSelect === void 0 ? void 0 : _diffItem$styleSelect.selectedId;
  }, [diffItem.styleSelectableDimensions]);
  const currentDiffStyle = useMemo(() => {
    return diffItem.diffStyleId;
  }, [diffItem.diffStyleId]);
  const availableDiffStyles = useMemo(() => {
    return filterOutUndefined(diffItem.availableDiffStyles.map(diffStyleId => {
      var _diffItem$styleSelect2;
      return (_diffItem$styleSelect2 = diffItem.styleSelectableDimensions) === null || _diffItem$styleSelect2 === void 0 || (_diffItem$styleSelect2 = _diffItem$styleSelect2[0]) === null || _diffItem$styleSelect2 === void 0 || (_diffItem$styleSelect2 = _diffItem$styleSelect2.options) === null || _diffItem$styleSelect2 === void 0 ? void 0 : _diffItem$styleSelect2.find(style => style.id === diffStyleId);
    }));
  }, [diffItem.availableDiffStyles, diffItem.styleSelectableDimensions]);
  const diffLegendUrl = useMemo(() => {
    return currentDiffStyle && currentLeftDate && currentRightDate && diffItem.getLegendUrlForStyle(currentDiffStyle, currentLeftDate, currentRightDate);
  }, [currentDiffStyle, currentLeftDate, currentRightDate, diffItem]);
  const previewLegendUrl = useMemo(() => {
    return previewStyle && diffItem.getLegendUrlForStyle(previewStyle);
  }, [previewStyle, diffItem]);
  const showItem = useCallback(model => {
    runInAction(() => {
      if (hasOpacity(model)) {
        model.setTrait(CommonStrata.user, "opacity", 0.8);
      }
    });
  }, []);
  const hideItem = useCallback(model => {
    runInAction(() => {
      if (hasOpacity(model)) {
        model.setTrait(CommonStrata.user, "opacity", 0);
      }
    });
  }, []);
  const handleChangeSourceItem = useCallback(e => {
    const newSourceItem = diffableItemsInWorkbench.find(item => item.uniqueId === e.target.value);
    if (newSourceItem) props.changeSourceItem(newSourceItem);
  }, [diffableItemsInWorkbench, props]);
  const handleChangePreviewStyle = useCallback(e => {
    const styleId = e.target.value;
    runInAction(() => {
      var _leftItem$styleSelect, _rightItem$styleSelec;
      (_leftItem$styleSelect = leftItem.styleSelectableDimensions) === null || _leftItem$styleSelect === void 0 || (_leftItem$styleSelect = _leftItem$styleSelect[0]) === null || _leftItem$styleSelect === void 0 || _leftItem$styleSelect.setDimensionValue(CommonStrata.user, styleId);
      (_rightItem$styleSelec = rightItem.styleSelectableDimensions) === null || _rightItem$styleSelec === void 0 || (_rightItem$styleSelec = _rightItem$styleSelec[0]) === null || _rightItem$styleSelec === void 0 || _rightItem$styleSelec.setDimensionValue(CommonStrata.user, styleId);
    });
  }, [leftItem.styleSelectableDimensions, rightItem.styleSelectableDimensions]);
  const handleChangeDiffStyle = useCallback(e => {
    runInAction(() => {
      diffItem.setTrait(CommonStrata.user, "diffStyleId", e.target.value);
    });
  }, [diffItem]);
  const onUserPickingLocation = useCallback(_pickingLocation => {
    setIsPickingNewLocation(true);
  }, []);
  const onUserPickLocation = useCallback((pickedFeatures, pickedLocationValue) => {
    const feature = pickedFeatures.features.find(f => doesFeatureBelongToItem(f, leftItem) || doesFeatureBelongToItem(f, rightItem));
    runInAction(() => {
      if (feature) {
        leftItem.setTimeFilterFeature(feature, pickedFeatures.providerCoords);
        rightItem.setTimeFilterFeature(feature, pickedFeatures.providerCoords);
        setLocation(pickedLocationValue);
        setLocationPickError(false);
      } else {
        setLocationPickError(true);
      }
      setIsPickingNewLocation(false);
    });
  }, [leftItem, rightItem]);
  const unsetDates = useCallback(() => {
    runInAction(() => {
      leftItem.setTrait(CommonStrata.user, "currentTime", null);
      rightItem.setTrait(CommonStrata.user, "currentTime", null);
    });
    hideItem(leftItem);
    hideItem(rightItem);
  }, [leftItem, rightItem, hideItem]);
  const generateDiff = useCallback(() => {
    if (currentLeftDate === undefined || currentRightDate === undefined || currentDiffStyle === undefined) {
      return;
    }
    runInAction(() => {
      terria.overlays.remove(leftItem);
      terria.overlays.remove(rightItem);
      terria.workbench.add(diffItem);
      diffItem.setTrait(CommonStrata.user, "name", diffItemName);
      diffItem.showDiffImage(currentLeftDate, currentRightDate, currentDiffStyle);
      const diffItemProperties = diffItem.diffItemProperties;
      if (diffItemProperties) {
        updateModelFromJson(diffItem, CommonStrata.user, diffItemProperties);
      }
      terria.showSplitter = false;
    });
  }, [currentDiffStyle, currentLeftDate, currentRightDate, diffItem, diffItemName, leftItem, rightItem, terria]);
  const resetTool = useCallback(() => {
    runInAction(() => {
      diffItem.clearDiffImage();
      setDefaultDiffStyle(diffItem);
      terria.overlays.add(leftItem);
      terria.overlays.add(rightItem);
      terria.workbench.remove(diffItem);
      terria.showSplitter = true;
      leftItem.setTrait(CommonStrata.user, "splitDirection", SplitDirection.LEFT);
      rightItem.setTrait(CommonStrata.user, "splitDirection", SplitDirection.RIGHT);
    });
  }, [diffItem, leftItem, rightItem, terria]);
  const setLocationFromActiveSearch = useCallback(async () => {
    const markerLocation = getMarkerLocation(terria);
    if (markerLocation && MappableMixin.isMixedInto(sourceItem)) {
      const part = sourceItem.mapItems.find(p => ImageryParts.is(p));
      const imageryProvider = part && ImageryParts.is(part) && part.imageryProvider;
      if (imageryProvider) {
        const promises = [setTimeFilterFromLocation(leftItem, markerLocation, imageryProvider), setTimeFilterFromLocation(rightItem, markerLocation, imageryProvider)];
        const someSuccessful = (await Promise.all(promises)).some(ok => ok);
        if (someSuccessful) {
          runInAction(() => setLocation(markerLocation));
        } else {
          // If we cannot resolve imagery at the marker location, remove it
          runInAction(() => removeMarker(terria));
        }
      }
    }
  }, [leftItem, rightItem, sourceItem, terria]);
  useEffect(() => {
    const {
      latitude,
      longitude,
      height
    } = diffItem.timeFilterCoordinates;
    if (latitude !== undefined && longitude !== undefined) {
      setLocation({
        latitude,
        longitude,
        height
      });
      // Assuming removeMarker is an action or handles its own MobX transactions
      removeMarker(terria);
    } else {
      setLocationFromActiveSearch();
    }
  }, [diffItem.timeFilterCoordinates, setLocationFromActiveSearch, terria]);
  const closePanel = useCallback(() => {
    viewState.closeTool();
  }, [viewState]);
  const isShowingDiff = diffItem.isShowingDiff;
  const datesSelected = currentLeftDate && currentRightDate;
  const isReadyToGenerateDiff = location && datesSelected && currentDiffStyle !== undefined;
  return /*#__PURE__*/_jsx(WorkflowPanel, {
    viewState: viewState,
    title: t("diffTool.title"),
    icon: GLYPHS.difference,
    onClose: () => {
      resetTool();
      closePanel();
    },
    children: /*#__PURE__*/_jsxs(_StyledDiv, {
      children: [isShowingDiff && /*#__PURE__*/_jsx(Text, {
        medium: true,
        textLight: true,
        children: t("diffTool.differenceResultsTitle")
      }), /*#__PURE__*/_jsx(Text, {
        textLight: true,
        children: t("diffTool.instructions.paneDescription")
      }), /*#__PURE__*/_jsx(Group, {
        children: /*#__PURE__*/_jsxs(LocationAndDatesDisplayBox, {
          children: [/*#__PURE__*/_jsxs(Box, {
            children: [/*#__PURE__*/_jsxs(Text, {
              medium: true,
              children: [t("diffTool.labels.area"), ":"]
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(Text, {
                bold: true,
                textLight: true,
                children: location ? t("diffTool.locationDisplay.locationSelected.title") : t("diffTool.locationDisplay.noLocationSelected.title")
              }), /*#__PURE__*/_jsx(Text, {
                light: true,
                textLight: true,
                small: true,
                children: location ? t("diffTool.locationDisplay.locationSelected.description") : t("diffTool.locationDisplay.noLocationSelected.description")
              })]
            })]
          }), /*#__PURE__*/_jsxs(Box, {
            children: [/*#__PURE__*/_jsxs(Text, {
              medium: true,
              children: [t("diffTool.labels.dates"), ":"]
            }), /*#__PURE__*/_jsxs(Box, {
              column: true,
              alignItemsFlexStart: true,
              children: [currentLeftDate && /*#__PURE__*/_jsxs(Text, {
                large: true,
                children: ["(A)", " ", dateFormat(JulianDate.toDate(currentLeftDate), "dd/mm/yyyy")]
              }), !currentLeftDate && /*#__PURE__*/_jsx(RawButton, {
                onClick: () => {
                  var _leftDatePickerHandle;
                  return (_leftDatePickerHandle = leftDatePickerHandle.current) === null || _leftDatePickerHandle === void 0 ? void 0 : _leftDatePickerHandle.open();
                },
                children: /*#__PURE__*/_jsx(TextSpan, {
                  isLink: true,
                  small: true,
                  bold: true,
                  children: t("diffTool.instructions.setDateA")
                })
              }), currentRightDate && /*#__PURE__*/_jsxs(Text, {
                large: true,
                children: ["(B)", " ", dateFormat(JulianDate.toDate(currentRightDate), "dd/mm/yyyy")]
              }), !currentRightDate && /*#__PURE__*/_jsx(RawButton, {
                onClick: () => {
                  var _rightDatePickerHandl;
                  return (_rightDatePickerHandl = rightDatePickerHandle.current) === null || _rightDatePickerHandl === void 0 ? void 0 : _rightDatePickerHandl.open();
                },
                children: /*#__PURE__*/_jsx(TextSpan, {
                  isLink: true,
                  small: true,
                  bold: true,
                  children: t("diffTool.instructions.setDateB")
                })
              }), isShowingDiff === false && currentLeftDate && currentRightDate && /*#__PURE__*/_jsx(RawButton, {
                onClick: unsetDates,
                children: /*#__PURE__*/_jsx(TextSpan, {
                  isLink: true,
                  small: true,
                  children: t("diffTool.instructions.changeDates")
                })
              })]
            })]
          })]
        })
      }), !isShowingDiff && /*#__PURE__*/_jsx(Group, {
        children: /*#__PURE__*/_jsxs(Selector, {
          viewState: viewState,
          value: sourceItem.uniqueId,
          onChange: handleChangeSourceItem,
          label: t("diffTool.labels.sourceDataset"),
          children: [/*#__PURE__*/_jsx("option", {
            disabled: true,
            children: "Select source item"
          }), diffableItemsInWorkbench.map(item => /*#__PURE__*/_jsx("option", {
            value: item.uniqueId,
            children: item.name
          }, item.uniqueId))]
        })
      }), !isShowingDiff && /*#__PURE__*/_jsxs(Group, {
        children: [/*#__PURE__*/_jsxs(Selector, {
          viewState: viewState,
          spacingBottom: true,
          value: previewStyle,
          onChange: handleChangePreviewStyle,
          label: t("diffTool.labels.previewStyle"),
          children: [/*#__PURE__*/_jsx("option", {
            disabled: true,
            value: "",
            children: t("diffTool.choosePreview")
          }), (_diffItem$styleSelect3 = diffItem.styleSelectableDimensions) === null || _diffItem$styleSelect3 === void 0 || (_diffItem$styleSelect3 = _diffItem$styleSelect3[0]) === null || _diffItem$styleSelect3 === void 0 || (_diffItem$styleSelect3 = _diffItem$styleSelect3.options) === null || _diffItem$styleSelect3 === void 0 ? void 0 : _diffItem$styleSelect3.map(style => /*#__PURE__*/_jsx("option", {
            value: style.id,
            children: style.name
          }, style.id))]
        }), previewLegendUrl && /*#__PURE__*/_jsx(LegendImage, {
          width: "100%",
          src: previewLegendUrl
        })]
      }), /*#__PURE__*/_jsxs(Group, {
        children: [/*#__PURE__*/_jsxs(Selector, {
          viewState: viewState,
          value: currentDiffStyle || "",
          onChange: handleChangeDiffStyle,
          label: t("diffTool.labels.differenceOutput"),
          children: [/*#__PURE__*/_jsx("option", {
            disabled: true,
            value: "",
            children: t("diffTool.chooseDifference")
          }), availableDiffStyles.map(style => /*#__PURE__*/_jsx("option", {
            value: style.id,
            children: style.name
          }, style.id))]
        }), isShowingDiff && diffLegendUrl && /*#__PURE__*/_jsx(LegendImage, {
          width: "100%",
          src: diffLegendUrl
        })]
      }), !isShowingDiff && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(GenerateButton, {
          onClick: generateDiff,
          disabled: !isReadyToGenerateDiff,
          "aria-describedby": "TJSDifferenceDisabledButtonPrompt",
          children: /*#__PURE__*/_jsx(TextSpan, {
            large: true,
            children: t("diffTool.labels.generateDiffButtonText")
          })
        }), !isReadyToGenerateDiff && /*#__PURE__*/_jsxs(_StyledDiv2, {
          children: [/*#__PURE__*/_jsx(_StyledDiv3, {
            children: /*#__PURE__*/_jsx(StyledIcon, {
              fillColor: "#ccc",
              styledWidth: "16px",
              styledHeight: "16px",
              glyph: GLYPHS.info
            })
          }), /*#__PURE__*/_jsx(Text, {
            small: true,
            light: true,
            textLight: true,
            id: "TJSDifferenceDisabledButtonPrompt",
            children: t("diffTool.labels.disabledButtonPrompt")
          })]
        })]
      }), isShowingDiff && /*#__PURE__*/_jsxs(Box, {
        centered: true,
        left: true,
        children: [/*#__PURE__*/_jsx(_StyledBackButton, {
          transparentBg: true,
          onClick: resetTool,
          $_css: theme.textLight,
          $_css2: theme.textLight,
          children: /*#__PURE__*/_jsxs(BoxSpan, {
            centered: true,
            children: [/*#__PURE__*/_jsx(_StyledStyledIcon, {
              light: true,
              styledWidth: "16px",
              glyph: GLYPHS.arrowDown
            }), /*#__PURE__*/_jsx(TextSpan, {
              medium: true,
              children: t("general.back")
            })]
          })
        }), /*#__PURE__*/_jsx(_StyledButton, {
          primary: true,
          onClick: closePanel,
          children: /*#__PURE__*/_jsx(TextSpan, {
            medium: true,
            children: t("diffTool.labels.saveToWorkbench")
          })
        })]
      }), !isShowingDiff && /*#__PURE__*/_jsx(LocationPicker, {
        terria: terria,
        location: location,
        onPicking: onUserPickingLocation,
        onPicked: onUserPickLocation
      }), !isShowingDiff && /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsxs(Box, {
        centered: true,
        fullWidth: true,
        flexWrap: true,
        backgroundColor: theme.dark,
        children: [/*#__PURE__*/_jsx(DatePicker, {
          ref: leftDatePickerHandle,
          heading: t("diffTool.labels.dateComparisonA"),
          item: leftItem,
          onDateSet: () => showItem(leftItem)
        }), /*#__PURE__*/_jsx(AreaFilterSelection, {
          location: location,
          isPickingNewLocation: isPickingNewLocation
        }), /*#__PURE__*/_jsx(DatePicker, {
          ref: rightDatePickerHandle,
          heading: t("diffTool.labels.dateComparisonB"),
          item: rightItem,
          onDateSet: () => showItem(rightItem)
        })]
      }), document.getElementById("TJS-BottomDockLastPortal"))]
    })
  });
});
Main.displayName = "Main";
const BackButton = styled(Button).attrs({
  secondary: true
}).withConfig({
  displayName: "DiffTool__BackButton",
  componentId: "sc-3vyhxu-0"
})([""]);
var _StyledBackButton = styled(BackButton).withConfig({
  displayName: "DiffTool___StyledBackButton",
  componentId: "sc-3vyhxu-1"
})(["color:", ";border-color:", ";"], p => p.$_css, p => p.$_css2);
const GenerateButton = styled(Button).attrs({
  primary: true,
  fullWidth: true
}).withConfig({
  displayName: "DiffTool__GenerateButton",
  componentId: "sc-3vyhxu-2"
})([""]);
const Selector = props => /*#__PURE__*/_jsx(Box, {
  fullWidth: true,
  column: true,
  children: /*#__PURE__*/_jsxs("label", {
    children: [/*#__PURE__*/_jsx(_StyledText, {
      textLight: true,
      $_css3: "p {margin: 0;}",
      children: parseCustomMarkdownToReactWithOptions("".concat(props.label, ":"), {
        injectTermsAsTooltips: true,
        tooltipTerms: props.viewState.terria.configParameters.helpContentTerms
      })
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 1
    }), /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, props), {}, {
      children: props.children
    })), props.spacingBottom && /*#__PURE__*/_jsx(Spacing, {
      bottom: 2
    })]
  })
});
const AreaFilterSelection = props => {
  const {
    location,
    isPickingNewLocation
  } = props;
  const {
    t
  } = useTranslation();
  let locationText = "-";
  if (location) {
    const {
      longitude,
      latitude
    } = prettifyCoordinates(location.longitude, location.latitude, {
      digits: 2
    });
    locationText = "".concat(longitude, " ").concat(latitude);
  }
  return /*#__PURE__*/_jsxs(_StyledBox, {
    column: true,
    centered: true,
    styledMinWidth: "230px",
    children: [/*#__PURE__*/_jsxs(Box, {
      centered: true,
      children: [/*#__PURE__*/_jsx(StyledIcon, {
        light: true,
        styledWidth: "16px",
        glyph: GLYPHS.location2
      }), /*#__PURE__*/_jsx(Spacing, {
        right: 2
      }), /*#__PURE__*/_jsx(Text, {
        textLight: true,
        extraLarge: true,
        children: t("diffTool.labels.areaFilterSelection")
      })]
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 3
    }), /*#__PURE__*/_jsx(Box, {
      styledMinHeight: "40px",
      children: isPickingNewLocation ? /*#__PURE__*/_jsx(_StyledText2, {
        textLight: true,
        extraExtraLarge: true,
        bold: true
        // Using legacy Loader.jsx means we override at a higher level to inherit
        // this fills tyle
        ,
        children: /*#__PURE__*/_jsx(Loader, {
          light: true,
          message: "Querying ".concat(location ? "new" : "", " position...")
        })
      }) : /*#__PURE__*/_jsx(Text, {
        textLight: true,
        bold: true,
        heading: true,
        textAlignCenter: true,
        children: locationText
      })
    })]
  });
};
const Group = styled.div.withConfig({
  displayName: "DiffTool__Group",
  componentId: "sc-3vyhxu-3"
})(["background-color:", ";padding:15px;border-radius:5px;"], p => p.theme.darkWithOverlay);
const LocationAndDatesDisplayBox = styled(Box).attrs({
  column: true
}).withConfig({
  displayName: "DiffTool__LocationAndDatesDisplayBox",
  componentId: "sc-3vyhxu-4"
})(["color:", ";padding:15px;> ", ":first-child{margin-bottom:13px;}> div > div:first-child{margin-right:5px;min-width:50px;}"], p => p.theme.textLight, Box);
const LegendImage = function (props) {
  return /*#__PURE__*/_jsx("img", _objectSpread(_objectSpread({}, props), {}, {
    // Show the legend only if it loads successfully, so we start out hidden
    style: {
      display: "none",
      marginTop: "10px"
    },
    onLoad: e => e.currentTarget.style.display = "block",
    onError: e => e.currentTarget.style.display = "none"
  }));
};
async function createSplitItem(sourceItem, splitDirection) {
  const terria = sourceItem.terria;
  const ref = new SplitItemReference(createGuid(), terria);
  ref.setTrait(CommonStrata.user, "splitSourceItemId", sourceItem.uniqueId);
  terria.addModel(ref);
  await ref.loadReference();
  return runInAction(() => {
    var _newItem$styleSelecta;
    if (ref.target === undefined) {
      throw Error("failed to split item");
    }
    const newItem = ref.target;
    newItem.setTrait(CommonStrata.user, "show", true);
    newItem.setTrait(CommonStrata.user, "splitDirection", splitDirection);
    newItem.setTrait(CommonStrata.user, "currentTime", null);
    newItem.setTrait(CommonStrata.user, "initialTimeSource", "none");
    if (hasOpacity(newItem)) {
      // We want to show the item on the map only after date selection. At the
      // same time we cannot set `show` to false because if we
      // do so, date picking which relies on feature picking, will not work. So
      // we simply set the opacity of the item to 0.
      newItem.setTrait(CommonStrata.user, "opacity", 0);
    }

    // Override feature info template as the parent featureInfoTemplate might
    // not be relevant for the difference item. This has to be done in the user
    // stratum to override template set in definition stratum.
    updateModelFromJson(newItem, CommonStrata.user, {
      featureInfoTemplate: {
        template: ""
      }
    });
    setDefaultDiffStyle(newItem);

    // Set the default style to true color style if it exists
    const trueColor = (_newItem$styleSelecta = newItem.styleSelectableDimensions) === null || _newItem$styleSelecta === void 0 || (_newItem$styleSelecta = _newItem$styleSelecta[0]) === null || _newItem$styleSelecta === void 0 || (_newItem$styleSelecta = _newItem$styleSelecta.options) === null || _newItem$styleSelecta === void 0 ? void 0 : _newItem$styleSelecta.find(style => isDefined(style.name) && style.name.search(/true/i) >= 0);
    if (trueColor !== null && trueColor !== void 0 && trueColor.id) {
      var _newItem$styleSelecta2;
      (_newItem$styleSelecta2 = newItem.styleSelectableDimensions) === null || _newItem$styleSelecta2 === void 0 || (_newItem$styleSelecta2 = _newItem$styleSelecta2[0]) === null || _newItem$styleSelecta2 === void 0 || _newItem$styleSelecta2.setDimensionValue(CommonStrata.user, trueColor.id);
    }
    terria.overlays.add(newItem);
    return newItem;
  });
}

/**
 * If the item has only one available diff style, auto-select it
 */
function setDefaultDiffStyle(item) {
  if (item.diffStyleId !== undefined) {
    return;
  }
  const availableStyles = filterOutUndefined(item.availableDiffStyles.map(diffStyleId => {
    var _item$styleSelectable;
    return (_item$styleSelectable = item.styleSelectableDimensions) === null || _item$styleSelectable === void 0 || (_item$styleSelectable = _item$styleSelectable[0]) === null || _item$styleSelectable === void 0 || (_item$styleSelectable = _item$styleSelectable.options) === null || _item$styleSelectable === void 0 ? void 0 : _item$styleSelectable.find(style => style.id === diffStyleId);
  }));
  if (availableStyles.length === 1) {
    item.setTrait(CommonStrata.user, "diffStyleId", availableStyles[0].id);
  }
}
function removeSplitItem(item) {
  const terria = item.terria;
  terria.overlays.remove(item);
  if (item.sourceReference && terria.workbench.contains(item) === false) {
    terria.removeModelReferences(item.sourceReference);
  }
}
function doesFeatureBelongToItem(feature, item) {
  var _feature$imageryLayer;
  if (!MappableMixin.isMixedInto(item)) return false;
  const imageryProvider = (_feature$imageryLayer = feature.imageryLayer) === null || _feature$imageryLayer === void 0 ? void 0 : _feature$imageryLayer.imageryProvider;
  if (imageryProvider === undefined) return false;
  return item.mapItems.find(m => ImageryParts.is(m) && m.imageryProvider === imageryProvider) !== undefined;
}
function setTimeFilterFromLocation(item, location, im) {
  const carto = new Cartographic(CesiumMath.toRadians(location.longitude), CesiumMath.toRadians(location.latitude));
  // We just need to set this to a high enough level supported by the service
  const level = 30;
  const tile = im.tilingScheme.positionToTileXY(carto, level);
  return item.setTimeFilterFromLocation({
    position: {
      latitude: location.latitude,
      longitude: location.longitude,
      height: location.height
    },
    tileCoords: {
      x: tile.x,
      y: tile.y,
      level
    }
  });
}
function hasOpacity(model) {
  return hasTraits(model, ImageryProviderTraits, "opacity");
}
export default DiffTool;
var _StyledDiv = styled("div").withConfig({
  displayName: "DiffTool___StyledDiv",
  componentId: "sc-3vyhxu-5"
})(["display:flex;flex-direction:column;height:100%;padding:15px;gap:20px;"]);
var _StyledDiv2 = styled("div").withConfig({
  displayName: "DiffTool___StyledDiv2",
  componentId: "sc-3vyhxu-6"
})(["display:flex;flex-direction:row;padding:5px;"]);
var _StyledDiv3 = styled("div").withConfig({
  displayName: "DiffTool___StyledDiv3",
  componentId: "sc-3vyhxu-7"
})(["margin-right:10px;"]);
var _StyledStyledIcon = styled(StyledIcon).withConfig({
  displayName: "DiffTool___StyledStyledIcon",
  componentId: "sc-3vyhxu-8"
})(["transform:rotate(90deg);"]);
var _StyledButton = styled(Button).withConfig({
  displayName: "DiffTool___StyledButton",
  componentId: "sc-3vyhxu-9"
})(["flex-grow:1;margin-left:10px;"]);
var _StyledText = styled(Text).withConfig({
  displayName: "DiffTool___StyledText",
  componentId: "sc-3vyhxu-10"
})(["", ""], p => p.$_css3);
var _StyledBox = styled(Box).withConfig({
  displayName: "DiffTool___StyledBox",
  componentId: "sc-3vyhxu-11"
})(["@media (max-width:", "px){width:100%;}"], props => props.theme.md);
var _StyledText2 = styled(Text).withConfig({
  displayName: "DiffTool___StyledText2",
  componentId: "sc-3vyhxu-12"
})(["fill:", ";"], _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.textLight;
});